import { createAction } from "@reduxjs/toolkit";
import { LinkedAcctType } from "@pd/components/PlaidLink/types";
import { BuyerPortalStateType } from "../types";
import {
  FlowSubTypes,
  FlowTypes,
  NextFlowTypes,
  NextFlowPropType,
} from "../types/modalTypes";

const actions = {
  fetching: createAction(
    "portal/fetching",
    (fetching: boolean, stateKey: keyof BuyerPortalStateType) => ({
      payload: { fetching, stateKey },
    }),
  ),
  apiError: createAction(
    "portal/apiError",
    (error: string, stateKey: keyof BuyerPortalStateType) => ({
      payload: { error, stateKey },
    }),
  ),
  transition: createAction(
    "portal/transition",
    (
      caller: FlowTypes,
      actionTaken: FlowTypes | FlowSubTypes,
      props?: NextFlowPropType,
    ) => ({
      payload: { caller, actionTaken, props },
    }),
  ),
  changeRoute: createAction("portal/changeRoute", (route: string) => ({
    payload: { route },
  })),
  open: createAction(
    "portal/open",
    (modal: NextFlowTypes, props?: NextFlowPropType) => ({
      payload: { modal, props },
    }),
  ),
  close: createAction("portal/close", () => ({
    payload: {},
  })),
  confirmPayment: createAction("portal/confirmPayment"),
  setPaymentMethod: createAction(
    "portal/setPaymentMethod",
    (paymentMethod: LinkedAcctType) => ({
      payload: { paymentMethod },
    }),
  ),
  setPaymentDate: createAction("portal/setPaymentDate", (date: string) => ({
    payload: { date },
  })),
};
export default actions;
